const PROMOTION_CODES_SUCCESS = 'PROMOTION_CODES_SUCCESS';
const CREATE_PROMOTION_CODE_SUCCESS = 'CREATE_PROMOTION_CODE_SUCCESS';
const PROMOTION_CODES_FAILURE = 'PROMOTION_CODES_FAILURE';
const GET_PROMOTION_CODES = 'GET_PROMOTION_CODES';
const SET_CURRENT = 'SET_CURRENT';
const CLEAR_PROMOTION_CODES = 'CLEAR_PROMOTION_CODES';
const PROMOTION_CODES_GENERATE_SUCCESS = 'PROMOTION_CODES_GENERATE_SUCCESS';
const PROMOTION_CODES_CLEAR_ERROR = 'PROMOTION_CODES_CLEAR_ERROR';
const CREATE_PROMOTION_CODES_FAILURE = 'CREATE_PROMOTION_CODES_FAILURE';
const CREATE_PROMOTION_CODES = 'CREATE_PROMOTION_CODES';
const PROMOTION_CODE_EDIT_CODE_SUCCESS = 'PROMOTION_CODE_EDIT_CODE_SUCCESS';
const GET_REFERRAL_CODES = 'GET_REFERRAL_CODES';
const GET_REFERRAL_CODES_SUCCESS = 'GET_REFERRAL_CODES_SUCCESS';
const GET_REFERRAL_CODES_FAILURE = 'GET_REFERRAL_CODES_FAILURE';
const CLEAR_REFERRAL_CODES = 'CLEAR_REFERRAL_CODES';
const PromotionCodesSymbols = {
  PROMOTION_CODES_SUCCESS,
  PROMOTION_CODES_FAILURE,
  GET_PROMOTION_CODES,
  SET_CURRENT,
  CLEAR_PROMOTION_CODES,
  CREATE_PROMOTION_CODE_SUCCESS,
  PROMOTION_CODES_GENERATE_SUCCESS,
  PROMOTION_CODES_CLEAR_ERROR,
  CREATE_PROMOTION_CODES_FAILURE,
  CREATE_PROMOTION_CODES,
  PROMOTION_CODE_EDIT_CODE_SUCCESS,
  GET_REFERRAL_CODES,
  GET_REFERRAL_CODES_SUCCESS,
  GET_REFERRAL_CODES_FAILURE,
  CLEAR_REFERRAL_CODES,
};
export default PromotionCodesSymbols;
